import { SaleChangeStatusEnum, type SaleChange } from '@src/domains/sale-changes/types/saleChange';

interface Params {
  lastSaleChange: SaleChange | null;
  isRescheduleDone: boolean;
  appliedFeedbackSaleChangeId: string | null;
}

export function shouldShowSaleChangeStatus({
  lastSaleChange,
  isRescheduleDone,
  appliedFeedbackSaleChangeId,
}: Params): boolean {
  if (!lastSaleChange) return false;

  if (
    lastSaleChange.status === SaleChangeStatusEnum.Pending ||
    lastSaleChange.status === SaleChangeStatusEnum.Expired
  ) {
    return true;
  }

  return isRescheduleDone || appliedFeedbackSaleChangeId === lastSaleChange.id;
}
